import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { StatisticProvider } from '@internal-providers/statistic.provider';
import { IStatistic, IStatisticParams } from '@shared-libs/interfaces';

@Component({
	selector: 'cancellations-on-target-audiences-statistic-component',
	templateUrl: 'cancellations-on-target-audiences-statistic.component.html',
	styleUrls: ['./cancellations-on-target-audiences-statistic.component.scss'],
})
export class CancellationsOnTargetAudiencesStatisticComponent implements OnInit {
	@Input() public params: IStatisticParams;
	@Input() public paramsChanged: EventEmitter<IStatisticParams>;
	public dataRequest: () => Promise<IStatistic>;

	constructor(private readonly provider: StatisticProvider) {}

	public ngOnInit(): void {
		this.dataRequest = () => this.provider.getCancellationsOnTargetAudiencesStatistic(this.params);
		this.paramsChanged.subscribe((params) => {
			this.dataRequest = () => this.provider.getCancellationsOnTargetAudiencesStatistic(params);
		});
	}
}
